export default "__VITE_ASSET__CuutUV5N__"